<template>
  <div
    v-if="isLoadingGlobal"
    class="global-loading"
  >
    <div class="global-spinner" />
  </div>
</template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import { useLoading } from '@/composables/useLoading'; 
  
  export default defineComponent({
    setup() {
      const { isLoadingGlobal } = useLoading(); 
  
      return { isLoadingGlobal };
    },
  });
  </script>
  
  <style scoped>
  .global-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .global-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
  